import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import PropTypes from 'prop-types';

export class CheckGitlabAccess extends React.PureComponent {
    state = {
        loading: true,
        needLogin: false,
        gitlabUser: null,
        state: null,
        appId: null,
    };

    componentDidMount() {
        if (window.location.search) {
            let code = null;
            let state = null;
            for (let pair of window.location.search.substring(1).split('&')) {
                const values = pair.split('=');
                if (values[0] === 'code') {
                    code = values[1];
                } else if (values[0] === 'state') {
                    state = values[1];
                }
            }
            if (code && state) {
                const request = {
                    code, state, redirect_uri: this.getRedirectUri(),
                };
                fetch('/api/gitlab/login', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(request),
                }).then(res => res.json())
                    .then(result => {
                        if (result.error) {
                            this.setState({ loading: false, error: result.error });
                        } else {
                            this.setState({ loading: false, gitlabUser: result.user });
                        }
                    });
                return;
            }
        }
        fetch('/api/gitlab/me').then(res => res.json())
            .then(result => {
                window.gitlabProjectPrefix = result.gitlabProjectPrefix;
                if (result.error) {
                    this.setState({ loading: false, needLogin: true, state: result.state, appId: result.appId });
                } else {
                    this.setState({ loading: false });
                }
            });
    }

    getRedirectUri() {
        return window.location.origin + "/editor";
    }

    loginGitlab = () => {
        window.location.href = `https://gitlab.corp.dreamcraft.com/oauth/authorize?client_id=${this.state.appId}&redirect_uri=${this.getRedirectUri()}&response_type=code&state=${this.state.state}&scope=api`;
    }

    skipLogin = () => {
        this.setState({ needLogin: false });
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        if (this.state.needLogin) {
            return (<Dialog open>
                <DialogTitle>
                    Gitlab Authorization Required
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Wild Sky Editor requires gitlab access to read/write files.
                        Please login with a gitlab account with access to wild sky repositories and authorize Wild Sky Editor to use gitlab API on behavior of your gitlab account.
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button color="primary" onClick={this.skipLogin}>Skip</Button>
                    <Button color="primary" onClick={this.loginGitlab}>Login Gitlab</Button>
                </DialogActions>
            </Dialog>);
        }
        if (this.state.error) {
            return <div>{JSON.stringify(this.state.error)}</div>;
        }
        return <React.Fragment>{this.props.children}</React.Fragment>;
    }
}

CheckGitlabAccess.propTypes = {
    children: PropTypes.object.isRequired,
};
